export enum ReportCategoryName {
  dealerClaimsReports = 'Dealer Claims Reports',
  dealerSalesReports = 'Dealer Sales Reports',
  dealerPerformanceReports = 'Dealer Performance Reports',
  invoicesStatememts = 'Invoices/Statements',
  dealerStatements = 'Dealer Statements',
}
